import { render, staticRenderFns } from "./IncomeTaxPayRun.vue?vue&type=template&id=591487a4&scoped=true&"
import script from "./IncomeTaxPayRun.vue?vue&type=script&lang=js&"
export * from "./IncomeTaxPayRun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591487a4",
  null
  
)

export default component.exports